import * as React from "react";
import { forwardRef } from "react";
const SvgIconRateApp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.6 15.65L12 13.8L14.4 15.65L13.5 12.6L15.75 11H12.95L12 7.9L11.05 11H8.25L10.5 12.6L9.6 15.65ZM5.825 21L8.15 13.4L2 9H9.6L12 1L14.4 9H22L15.85 13.4L18.175 21L12 16.3L5.825 21Z", fill: "black" }));
const ForwardRef = forwardRef(SvgIconRateApp);
export default ForwardRef;
